import(/* webpackMode: "eager" */ "/vercel/path0/src/app/artigos/page.tsx");
